import React from 'react';
import { Box } from '@mui/material';

import type { StatusColor } from '../../util/constants';

type Props = {
  label: React.ReactNode;
  color: StatusColor;
};

/** The one pill used for step status, token expiry, and the queue's completion badge. */
export const StatusChip = ({ label, color }: Props) => (
  <Box
    component="span"
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 0.5,
      px: 1,
      py: 0.25,
      borderRadius: '10px',
      fontSize: 12,
      fontWeight: 600,
      lineHeight: '20px',
      backgroundColor: color.bg,
      color: color.text,
      whiteSpace: 'nowrap',
    }}
  >
    {label}
  </Box>
);
